/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Shots_RevolveInputs */

const en_vc_shots_revolve = /** @type {(inputs: Vc_Shots_RevolveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D Revolve with smooth vector shading in VectorCraft`)
};

const zh_vc_shots_revolve = /** @type {(inputs: Vc_Shots_RevolveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 的 3D 绕转与平滑矢量明暗`)
};

/**
* | output |
* | --- |
* | "3D Revolve with smooth vector shading in VectorCraft" |
*
* @param {Vc_Shots_RevolveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_shots_revolve = /** @type {((inputs?: Vc_Shots_RevolveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Shots_RevolveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_shots_revolve(inputs)
	return zh_vc_shots_revolve(inputs)
});
export { vc_shots_revolve as "vc.shots.revolve" }